import { useEffect } from "react";

interface ToastProps {
  message: string;
  visible: boolean;
  onClose: () => void;
}

export default function Toast({ message, visible, onClose }: ToastProps) {
  useEffect(() => {
    if (!visible) return;
    const timer = window.setTimeout(onClose, 2400);
    return () => window.clearTimeout(timer);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed left-1/2 bottom-10 z-[60] -translate-x-1/2 animate-fade-up">
      <div className="flex items-center gap-2 rounded-full bg-foreground-950 px-5 py-3 text-sm text-background-50 shadow-lg">
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-checkbox-circle-fill text-accent-400" />
        </span>
        {message}
      </div>
    </div>
  );
}